/**
 * v2 BK-Liste für /betreuungen.
 *
 * Ersetzt für die BK-Liste den eingefrorenen v1-Endpunkt
 * `GET /v1/admin/users/1` (siehe `v1Users.byRole` in `src/lib/v1.ts`), der
 * NICHT geändert werden darf (Parallelbetrieb-Regel, CRM 1.0/2.0).
 *
 * Server: `GET /v2/admin/bk` (App\Http\Controllers\v2\Admin\BkListController).
 * Gleiche Query-Parameter wie der bisherige v1-Endpunkt (page, per_page,
 * filters[...], orderBy[field], orderBy[profile], order). Neue/erweiterte Filter:
 *   - `assigned_to`  Mehrfachauswahl (Array von Admin-IDs, wie in /pflege)
 *   - `sgb5_bk`      'true' = nur BK mit aktivem SGB5
 *
 * Die Zeilen sind mit `V1User` kompatibel (inkl. `profiles`, `currentContract`,
 * `assigned_admin_name`), `v1UserToCaregiver` bleibt unverändert nutzbar.
 */

import { apiV2 } from './api';
import type { ListParams, V1User } from './v1';

interface BkListResponse {
  data: V1User[];
  meta: { current_page: number; last_page: number; per_page: number; total: number };
  errors: unknown;
}

function buildBkListParams(p: ListParams = {}): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  if (p.page !== undefined) out.page = p.page;
  if (p.perPage !== undefined) out.per_page = p.perPage;

  const filters = p.filters ?? {};
  const keys = Object.keys(filters);
  if (keys.length === 0) {
    out['filters[_]'] = '1';
  } else {
    for (const k of keys) out[`filters[${k}]`] = filters[k];
  }

  if (p.orderBy) {
    out['orderBy[field]'] = p.orderBy.field;
    if (p.orderBy.profile) out['orderBy[profile]'] = 'true';
  }
  if (p.order !== undefined) out.order = p.order;
  return out;
}

export const bkList = {
  /** GET /v2/admin/bk → gleiche Seitenform wie `v1Users.byRole('BK', …)`. */
  list: async (
    params?: ListParams,
  ): Promise<{ data: V1User[]; current_page: number; last_page: number; per_page: number; total: number }> => {
    const res = await apiV2.get<BkListResponse>('/admin/bk', { params: buildBkListParams(params) });
    return { data: res.data.data, ...res.data.meta };
  },
};
